export const locationData = {

  // ======================================================
  // COSTA RICA
  // ======================================================

  "Costa Rica": {
    provinces: {

      Alajuela: [
        "Alajuela",
        "Atenas",
        "Grecia",
        "Guatuso",
        "Los Chiles",
        "Naranjo",
        "Orotina",
        "Palmares",
        "Poás",
        "Río Cuarto",
        "San Carlos",
        "San Ramón",
        "Upala",
        "Valverde Vega",
        "Zarcero"
      ],

      Cartago: [
        "Alvarado",
        "Cartago",
        "El Guarco",
        "Jiménez",
        "La Unión",
        "Oreamuno",
        "Paraíso",
        "Turrialba"
      ],

      Guanacaste: [
        "Abangares",
        "Bagaces",
        "Cañas",
        "Carrillo",
        "Hojancha",
        "La Cruz",
        "Liberia",
        "Nandayure",
        "Nicoya",
        "Santa Cruz",
        "Tilarán"
      ],

      Heredia: [
        "Barva",
        "Belén",
        "Flores",
        "Heredia",
        "San Isidro",
        "San Pablo",
        "San Rafael",
        "Santa Bárbara",
        "Santo Domingo",
        "Sarapiquí"
      ],

      Limón: [
        "Guácimo",
        "Limón",
        "Matina",
        "Pococí",
        "Siquirres",
        "Talamanca"
      ],

      Puntarenas: [
        "Buenos Aires",
        "Corredores",
        "Coto Brus",
        "Esparza",
        "Garabito",
        "Golfito",
        "Montes de Oro",
        "Monteverde",
        "Osa",
        "Parrita",
        "Puerto Jiménez",
        "Puntarenas",
        "Quepos"
      ],

      "San José": [
        "Acosta",
        "Alajuelita",
        "Aserrí",
        "Curridabat",
        "Desamparados",
        "Dota",
        "Escazú",
        "Goicoechea",
        "León Cortés",
        "Montes de Oca",
        "Moravia",
        "Mora",
        "Pérez Zeledón",
        "Puriscal",
        "San José",
        "Santa Ana",
        "Tarrazú",
        "Tibás",
        "Turrubares",
        "Vázquez de Coronado"
      ]
    }
  },

  // ======================================================
  // CANADA
  // ======================================================

  Canada: {
    provinces: {

      Alberta: [
        "Airdrie",
        "Calgary",
        "Edmonton",
        "Fort McMurray",
        "Grande Prairie",
        "Lethbridge",
        "Medicine Hat",
        "Okotoks",
        "Red Deer",
        "Spruce Grove"
      ],

      "British Columbia": [
        "Abbotsford",
        "Burnaby",
        "Kamloops",
        "Kelowna",
        "Nanaimo",
        "Prince George",
        "Richmond",
        "Surrey",
        "Vancouver",
        "Victoria"
      ],

      Manitoba: [
        "Brandon",
        "Portage la Prairie",
        "Steinbach",
        "Thompson",
        "Winnipeg"
      ],

      "New Brunswick": [
        "Edmundston",
        "Fredericton",
        "Miramichi",
        "Moncton",
        "Saint John"
      ],

      "Newfoundland and Labrador": [
        "Corner Brook",
        "Gander",
        "Labrador City",
        "Mount Pearl",
        "St. John's"
      ],

      "Nova Scotia": [
        "Dartmouth",
        "Halifax",
        "New Glasgow",
        "Sydney",
        "Truro"
      ],

      Ontario: [
        "Brampton",
        "Hamilton",
        "Kingston",
        "Kitchener",
        "London",
        "Mississauga",
        "Ottawa",
        "Toronto",
        "Waterloo",
        "Windsor"
      ],

      Quebec: [
        "Gatineau",
        "Laval",
        "Longueuil",
        "Montreal",
        "Quebec City",
        "Sherbrooke",
        "Trois-Rivières"
      ],

      Saskatchewan: [
        "Moose Jaw",
        "Prince Albert",
        "Regina",
        "Saskatoon",
        "Swift Current"
      ]
    }
  },

  // ======================================================
  // PANAMA
  // ======================================================

  Panama: {
    provinces: {

      Bocas_del_Toro: [
        "Almirante",
        "Bocas del Toro",
        "Changuinola",
        "Guabito"
      ],

      Chiriquí: [
        "Boquete",
        "Bugaba",
        "David",
        "Puerto Armuelles",
        "Volcán"
      ],

      Coclé: [
        "Aguadulce",
        "Antón",
        "La Pintada",
        "Natá",
        "Penonomé"
      ],

      Colón: [
        "Cativá",
        "Colón",
        "Portobelo",
        "Sabanitas"
      ],

      Darién: [
        "La Palma",
        "Santa Fe",
        "Yaviza"
      ],

      Herrera: [
        "Chitré",
        "Las Minas",
        "Ocú",
        "Parita"
      ],

      "Los Santos": [
        "Guararé",
        "Las Tablas",
        "Pedasí",
        "Tonosí"
      ],

      Panamá: [
        "Arraiján",
        "Chepo",
        "La Chorrera",
        "Pacora",
        "Panamá City",
        "San Miguelito",
        "Tocumen"
      ],

      "Panamá Oeste": [
        "Arraiján",
        "Capira",
        "Chame",
        "La Chorrera",
        "San Carlos"
      ],

      Veraguas: [
        "Atalaya",
        "Mariato",
        "Santiago",
        "Soná"
      ]
    }
  }
};

export const identificationOptions = [
  {
    value: "legal",
    label: "Jurídica"
  },
  {
    value: "individual",
    label: "Física"
  }
];

export const timezoneOptions = [
  {
    value: "America/Costa_Rica",
    label: "Costa Rica"
  },
  {
    value: "America/Panama",
    label: "Panama"
  },
  {
    value: "America/Mexico_City",
    label: "Mexico City, Mexico"
  },
  {
    value: "America/Vancouver",
    label: "Vancouver, Canada"
  },
  {
    value: "America/Edmonton",
    label: "Calgary, Canada"
  },
  {
    value: "America/Toronto",
    label: "Toronto, Canada"
  }
];